import { createContext, useContext } from 'react';
import { Store } from 'redux';

import { Map } from 'immutable';

import { Selector } from './reselect';

export const ComposeAppContext = createContext<{ store: Store; state: Map<string, any> }>(null);

/**
 * A React useContext hook that selects from ComposeApp state
 *
 * @remarks
 * Assumes that the state is available via context
 *
 * @param selector - the selector to use with ComposeApp state
 */
export function useComposeAppGlobalState<R>(selector: Selector<any, R>): R {
  return selector(useContext(ComposeAppContext).state);
}
